import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './store';
import type { DecodedToken } from '../types/api';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function useDecodedToken(): DecodedToken | null {
    const token = useAppSelector((state) => state.auth.token);

    return useMemo(() => {
        if (!token) return null;
        return JSON.parse(atob(token.split('.')[1])) as DecodedToken;
    }, [token]);
}
